export const LIMIT_OF_ITEMS = 8;
export const MAX_INPUT = 99;
export const MIN_INPUT = 1;
export const MB_SIZE = 1048576;
